import { useState, useEffect, useCallback } from 'react';
import { hasMobileDevice } from '@yme/utils/common';
export const useTouchingSignInMenu = ({ ref, }) => {
    const [isTouched, setIsTouched] = useState(false);
    const isMobileDevice = hasMobileDevice();
    const handleOnTouchStart = useCallback((event) => {
        const currentElem = ref?.current?.contains(event.target);
        if (currentElem && !isTouched) {
            setIsTouched(true);
        }
        if (!currentElem) {
            setIsTouched(false);
        }
    }, [isTouched, ref]);
    useEffect(() => {
        if (isMobileDevice) {
            window.addEventListener('touchstart', handleOnTouchStart, false);
        }
        return () => {
            if (isMobileDevice) {
                window.removeEventListener('touchstart', handleOnTouchStart, false);
            }
        };
    }, [handleOnTouchStart, isMobileDevice]);
    return {
        isTouched,
    };
};
